module.exports = __webpack_public_path__ + "b0631a4b062657de51fcfd2b5863b9e7.png";


//////////////////
// WEBPACK FOOTER
// ./work/sociallyfox/img/science.png
// module id = 753
// module chunks = 0